import { useMsal } from "@azure/msal-react";
import { useEffect, useContext } from "react";
import UserContext from '../../contexts/UserContext';
import { requestAuthLoginBySSO } from '../../hooks/auth';
import { requestEmployeeByEmployeeId } from '../../hooks/employee';
import { useHistory } from 'react-router-dom';
import { requestGetUser } from "../../hooks/user";
import { jwtDecode } from "jwt-decode";

const MsalRedirectHandler = () => {
  const { instance, accounts } = useMsal();
  const { setAccessToken, setUser, setEmp, setIsLoggedIn } = useContext(UserContext);
  const history = useHistory();

  useEffect(() => {
    const initMSAL = async () => {
      // รอให้ MSAL initialize เสร็จก่อน
      await instance.initialize();

      const response = await instance.handleRedirectPromise();
      const account = accounts[0] || response?.account;
      if (!account) return;

      const email = account.idTokenClaims?.email || account.idTokenClaims?.preferred_username || account.username;
      if (!email) return;

      const dataSSO: any = await requestAuthLoginBySSO((email as string).toLowerCase());
      if (!dataSSO?.token) return;

      setAccessToken(dataSSO.token);
       const data: any = jwtDecode(dataSSO.token);

      const user_data = await requestGetUser(data.access_token, data.user_id);
      setUser(user_data);

      if (user_data.employee_id) {
        const emp_data = await requestEmployeeByEmployeeId({}, data.access_token, user_data.employee_id);
        setEmp(emp_data);
      }

      setIsLoggedIn(true);

      history.push("/cars");
    };

    initMSAL();
  }, []);

  return null;
};

export default MsalRedirectHandler;
